import { render, staticRenderFns } from "./indication-documents.vue?vue&type=template&id=a9f608cc"
import script from "./indication-documents.vue?vue&type=script&lang=js"
export * from "./indication-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports